import { useCallback } from "react";
import Select, { components } from "react-select";
import classnames from "classnames";
import { selectCustomStyles } from "./select-custom-styles";
import { componentStyles } from "./select-with-icon.scss";

const { Option } = components;

const SelectWithIcon = (props) => {
  const { className, value, isClearable, isSearchable, name, options, onChange } = props;

  const IconOption = useCallback((selectProps) => {
    const { data } = selectProps;
    const { iconComponent: SvgIcon, label } = data;
    return (
      <Option className="select-option-with-icon" {...selectProps}>
        {SvgIcon && <SvgIcon style={{ marginLeft: "4px" }} />}
        <span style={{ marginLeft: "8px" }}>{label}</span>
      </Option>
    );
  }, []);

  return (
    <>
      <Select
        className={classnames("select-with-icon", className)}
        value={value}
        classNamePrefix="select"
        isClearable={isClearable}
        isSearchable={isSearchable}
        name={name}
        options={options}
        onChange={onChange}
        styles={selectCustomStyles}
        components={{ Option: IconOption, SingleValue: IconOption }}
      />
      <style jsx>{componentStyles}</style>
    </>
  );
};

export default SelectWithIcon;
